import { useCallback } from 'react';
import { PaymentMethod } from '@frontend/api-payment-plans';
import { useTranslation } from '@frontend/i18n';
import { useAlert } from '@frontend/design-system';
import { PaymentMethodsList } from './views/payment-methods-list';

export type CardOnFileJustifiViews = 'payment-methods-list' | 'add-card-form';

export type CardOnFileJustifiUIrops = {
  personId: string | undefined;
  locationId: string | undefined;
  selectedPM?: PaymentMethod;
  view: CardOnFileJustifiViews;
  paymentAmount?: number;
  addCardFormContent: React.ReactNode;
  onSelectPaymentMethod: (paymentMethod: PaymentMethod) => void;
  onChangeView?: (view: CardOnFileJustifiViews) => void;
};
export const CardOnFileJustifiUI = ({
  onChangeView,
  onSelectPaymentMethod,
  addCardFormContent,
  view,
  personId,
  locationId,
  selectedPM,
}: CardOnFileJustifiUIrops) => {
  const { t } = useTranslation('payments');

  const onClickAddNewCard = () => {
    onChangeView?.('add-card-form');
  };

  const alerts = useAlert();

  const onDeletePaymentMethod = useCallback(() => {
    alerts.success(t('Payment method deleted successfully.'));
  }, [alerts]);

  const onError = useCallback(
    (message: string) => {
      alerts.error(message || t('An error occurred while processing your request.'));
    },
    [alerts]
  );

  return (
    <>
      {view === 'payment-methods-list' && (
        <PaymentMethodsList
          personId={personId}
          locationId={locationId}
          selectedPM={selectedPM}
          onError={onError}
          onClickAddNewCard={onClickAddNewCard}
          onSelectPaymentMethod={onSelectPaymentMethod}
          onDeletePaymentMethod={onDeletePaymentMethod}
        />
      )}
      {view === 'add-card-form' && addCardFormContent}
    </>
  );
};
